<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true">
        <el-form-item>
          
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="tasks" highlight-current-row v-loading="listLoading" style="width: 100%;" :height="bodyHeight-220">
      <el-table-column type="index" width="60">
      </el-table-column>
      <el-table-column prop="agentName" label="代理名称" min-width="100">
      </el-table-column>
      <el-table-column prop="dataSourceName" label="数据源" min-width="200">
      </el-table-column>
      <el-table-column prop="status" label="状态" width="100" align="center" >
        <template scope="scope">
          <i :class="formatStatusIcon(scope.row)"></i>
          {{formatStatus(scope.row)}}
        </template>
      </el-table-column>
      <el-table-column prop="errorMsg" label="错误消息" min-width="200">
      </el-table-column>
    </el-table>


    

  </section>
</template>

<script>
export default {
  name: 'taskexecutestate',
  props: ['bodyHeight'],
  data() {
    return {
      socket: {},
      listLoading: false,
      tasks: []
    }
  },
  methods: {
    // 显示转换
    formatStatus: function (row) {
      if (row.status === 0) {
        return '正在运行'
      } else if (row.status === 1) {
        return '已完成'
      } else if (row.status === 2) {
        return '错误'
      } else {
        return '未知'
      }
    },
    // 显示图标
    formatStatusIcon: function (row) {
      if (row.status === 0) {
        return 'el-icon-video-play Success'
      } else if (row.status === 1) {
        return 'el-icon-circle-check Success'
      } else if (row.status === 2) {
        return 'el-icon-error Danger'
      } else {
        return 'el-icon-info'
      }
    },
  // 获取列表
  getTasks: function () {
    let socket
    let key = this.getguid();
    var uri = 'ws://' + window.location.host + '/ws?identifier=' + key
    socket = new WebSocket(uri)
    socket.onopen = (e)=>{
      console.log('open');
      var command = {
        CommandName: 'GetTaskExecusteLogCommand',
        CommandKey: key
      }
      let msg = "@" + JSON.stringify(command)
      socket.send(msg)
      this.executeTask(key)
      //setTimeout(this.executeTask(), 1000)
    }
    socket.onclose = function (e) { console.log('closed') }
    socket.onmessage = (e) => {
      return (() => {
        if (e.data.indexOf("sys::ping") == -1) {
          let state = JSON.parse(e.data)
          let obj = this.tasks.find((item, index, arr) => {
            return item.key === state.key
          });

          
          if (obj) {
            Object.assign(obj, state);
          }
          else {
            this.tasks.push(state);
          }
        }
      })()
    }
    socket.onerror = function (e) { console.log('Error: ' + e.data) }
    this.socket = socket
  },
  getguid: function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  },
  executeTask: function (taskKey) {
    let para = this.$route.params.taskId
    let url = 'api/DataCollect/ExecuteTask?taskId=' + para + "&taskKey=" + taskKey
    this.$ajax({
      url: url,
      //loadingName: 'executeTaskLoading',
      success: (d) => {
        //this.getTasks()
      }
    })
  }
},
  mounted() {    
    setTimeout(this.getTasks(), 1000)
  }
  ,destroyed() {
    this.socket.close()
  }
}
</script>

<style>
  i.Success {
    color: #67C23A
  }
  i.Danger {
    color: #F56C6C
  }
  i.Info {
    color: #909399
  }
</style>